import { useReducer, useEffect, useRef } from "react";
import stepChartReducer, { combinedInitialState } from "./reducer";
import { fetchChargerMatrix, fetchPowerOfferings } from "./api";
import ACTIONS from "./actions";
import { transformChargerData, transformUserSetSchedulesData } from "../../../lib/utils/utility";

const FETCH_DEBOUNCE_MS = 1000;

async function getChargerMatrix(dispatch, chargerId, timeRange) {
  const [startTime, endTime] = timeRange ?? [];
  const startIso = startTime?.toISOString();
  const endIso = endTime?.toISOString();
  dispatch({ type: ACTIONS.FETCH_CHARGER_MATRIX_INIT });
  try {
    const [fullRes, userRes, powerOffering] = await Promise.allSettled([
      fetchChargerMatrix(chargerId, startIso, endIso),
      fetchChargerMatrix(chargerId, startIso, endIso, "UserSetSchedules"),
      fetchPowerOfferings(chargerId, startIso, endIso),
    ]);
    if (fullRes.status !== "fulfilled" || !fullRes.value) {
      dispatch({ type: ACTIONS.FETCH_CHARGER_MATRIX_FAILURE });
      return;
    }
    const dataMatrix = transformChargerData(fullRes.value, startTime, endTime);
    let userSetSchedulesSetpointPower = [];
    if (userRes.status === "fulfilled" && userRes.value) {
      userSetSchedulesSetpointPower = transformUserSetSchedulesData(userRes.value) || [];
    }
    let powerOfferingData = [];
    if (powerOffering.status === "fulfilled" && powerOffering.value) {
      powerOfferingData = powerOffering.value.data;
    }
    dispatch({
      type: ACTIONS.FETCH_CHARGER_MATRIX_SUCCESS,
      payload: {
        ...dataMatrix,
        userSetSchedulesSetpointPower,
        powerOfferingData,
      },
    });
  } catch (e) {
    dispatch({ type: ACTIONS.FETCH_CHARGER_MATRIX_FAILURE });
  }
}

export function useBarChartReducer({ chargerId, timeRange }) {
  const [state, dispatch] = useReducer(stepChartReducer, combinedInitialState);
  const lastFetchRef = useRef(null);

  useEffect(() => {
    if (!chargerId || !timeRange) return;

    const startIso = new Date(timeRange[0]).toISOString();
    const endIso = new Date(timeRange[1]).toISOString();
    const fetchKey = `${chargerId}_${startIso}_${endIso}`;

    const handler = setTimeout(() => {
      if (lastFetchRef.current === fetchKey) return;
      lastFetchRef.current = fetchKey;
      getChargerMatrix(dispatch, chargerId, timeRange);
    }, FETCH_DEBOUNCE_MS);

    return () => clearTimeout(handler);
  }, [chargerId, timeRange]);

  return {
    matrix: state.matrix,
    dispatch,
  };
}

export default useBarChartReducer;
